import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocationContextConfirmationService {
  private readonly locationContextConfirmedSubject = new BehaviorSubject(false);

  readonly locationContextConfirmed$ = this.locationContextConfirmedSubject.asObservable();

  get isLocationContextConfirmed(): boolean {
    return this.locationContextConfirmedSubject.value;
  }

  markConfirmed(): void {
    this.locationContextConfirmedSubject.next(true);
  }

  reset(): void {
    this.locationContextConfirmedSubject.next(false);
  }
}
